import React from 'react'
import _uniqBy from 'lodash/uniqBy'
import { formatDate } from '../../../common/helpers'
import { StyledList, LocalH3Style, StyledLeftDiv, StyledDiv } from './styles'
import { StyledExternalLink } from '../../../theme/Global'

const itemRender = (item) => (
  <li key={item.sku}>
    <StyledExternalLink href={item.downloadUrl} target="_blank">
      {item.jurisdictionName}
    </StyledExternalLink>
  </li>
)

export const localByType = (items, type) => items.filter((item) => item.jurisdictionType.toLowerCase() === type)

export const linkedUniqueItemsOnly = (items) => _uniqBy(items.filter((item) => item.downloadUrl !== ''), 'sku')

const PosterModalRenderer = ({ complianceDate, downloadUrl, local, name, size }) => {
  const localSet = linkedUniqueItemsOnly(local)

  const cityPosters = localByType(localSet, 'city')

  const countyPosters = localByType(localSet, 'county')

  return (
    <div>
      <div>
        <StyledExternalLink href={`${downloadUrl}`} target="_blank">
          {name} {size} Poster
        </StyledExternalLink>
      </div>
      <StyledDiv>Compliant as of: {complianceDate ? formatDate(complianceDate) : 'N/A'}</StyledDiv>
      <StyledLeftDiv>
        Select a file to view PDF versions of current Labor Law Postings that explain employee
        rights and responsibilities
      </StyledLeftDiv>
      {countyPosters.length > 0 ? (
        <React.Fragment>
          <LocalH3Style>County Posters</LocalH3Style>
          <StyledList>
            {countyPosters.map((item) => itemRender(item))}
          </StyledList>
        </React.Fragment>
      ) : null}
      {cityPosters.length > 0 ? (
        <React.Fragment>
          <LocalH3Style>City Posters</LocalH3Style>
          <StyledList>
            {cityPosters.map((item) => itemRender(item))}
          </StyledList>
        </React.Fragment>
      ) : null}
    </div>
  )
}

export default PosterModalRenderer
